import ChalkySticks from '@chalkysticks/sdk';
import State from './State';

/**
 * Getters are used to calculate values based off state. They are generally
 * used for filtering or formatting data.
 *
 * @class Getters
 * @package Store/Module/Authentication
 * @project ChalkySticks App
 */
const getters = {
	/**
	 * Global authentication model
	 *
	 * @param State state
	 * @return ChalkySticks.Model.Authentication
	 */
	authModel(state: typeof State): ChalkySticks.Model.Authentication {
		const authModel = ChalkySticks.Factory.Authentication.model({
			baseUrl: ChalkySticks.Core.Constants.API_URL_V3,
		});

		// Set attributes of existing User model
		authModel.user.set(state.user);

		// Set token of existing JWT model
		authModel.jwt.set({
			token: state.token,
			type: 'jwt',
		});

		return authModel;
	},

	/**
	 * Determine if we have passed the age gate
	 *
	 * @param State state
	 * @return boolean
	 */
	authenticated(state: typeof State): boolean {
		return !!state.token && !!state.user;
	},

	/**
	 * Determine if the user is a super admin
	 *
	 * @param State state
	 * @return boolean
	 */
	isSuperAdmin(state: typeof State): boolean {
		return state.user && (state.user?.id === 1 || state.user?.id === '1');
	},

	/**
	 * Returns the user's token
	 *
	 * @param State state
	 * @return string
	 */
	token(state: typeof State): string {
		return state.token;
	},

	/**
	 * Returns user model based off state properties
	 *
	 * @param State state
	 * @return ChalkySticks.Model.User
	 */
	user(state: typeof State): ChalkySticks.Model.User {
		return getters.authModel(state).user;
	},
};

export default getters;
